import React, { Suspense, lazy, useEffect } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import Main from "./info/pages/Main";
import { Layout } from "../_metronic/layout";
// import { Logout, AuthPage, LiceseList } from "./modules/Auth";
import LayoutAuth from "./modules/Auth/pages/Layout";
import Login from "./modules/Auth/pages/Login";
import Registration from "./modules/Auth/pages/Registration";
import PageId19 from "./modules/Auth/pages/PageId19";
import { Main as DMain } from "./pages/Main";
import { DashboardPage } from "./pages/DashboardPage";
import { PageId15 } from "./pages/PageId15";
import { BotMonitoring } from "./pages/BotMonitoring";
import { Book } from "./pages/Book";
import { BookSys } from "./pages/BookSys";
import { Schedule } from "./pages/Schedule";
import { BotStatus } from "./pages/BotStatus";
import { BotRate } from "./pages/BotRate";
import { BotWeekly } from "./pages/BotWeekly";
import { BotManage } from "./pages/BotManage";
import { BotAdminManage } from "./pages/BotAdminManage";
import { Notice } from "./pages/Notice";
import { LicenseManage } from "./pages/LicenseManage";
import { LicenseReqMng } from "./pages/LicenseReqMng";
import { LicenseBuyMng } from "./pages/LicenseBuyMng";
import { LicenseSysBuyMng } from "./pages/LicenseSysBuyMng";
import { LicenseSysManage } from "./pages/LicenseSysManage";
import LicenseList from "./modules/Auth/pages/LicenseList";
import BuyLicense from "./modules/Auth/pages/BuyLicense";
import { BotMain } from "./pages/BotMain";
import { PageId57 } from "./pages/PageId57";
const BasePage = lazy(() => import("./BasePage"));

function AppRoute({ ...params }) {
  return (
    <>
      <Layout>
        <Route {...params} />
      </Layout>
    </>
  );
}

export default function IndexPage() {
  console.log(localStorage.getItem("token"));
  return (
    <Switch>
      <AppRoute path="/" exact={true} component={DMain} />
      <Route path="/auth/login" exact={true} component={Login} />
      <Route path="/auth/registration" exact={true} component={Registration} />
      <Route path="/auth/pageId19" exact={true} component={PageId19} />
      <Route path="/licenseList" exact={true} component={LicenseList} />
      <Route path="/buyLicense" exact={true} component={BuyLicense} />
      <AppRoute path="/main" exact={true} component={DMain} />
      <AppRoute path="/book" exact={true} component={Book} />
      <AppRoute path="/bookSys" exact={true} component={BookSys} />
      <AppRoute path="/botMonitoring" exact={true} component={BotMonitoring} />
      <AppRoute path="/schedule" exact={true} component={Schedule} />
      <AppRoute path="/botStatus" exact={true} component={BotStatus} />
      <AppRoute path="/botRate" exact={true} component={BotRate} />
      <AppRoute path="/botManage" exact={true} component={BotManage} />
      <AppRoute
        path="/botAdminManage"
        exact={true}
        component={BotAdminManage}
      />
      <AppRoute path="/notice" exact={true} component={Notice} />
      <AppRoute path="/PageId57" exact={true} component={PageId57} />
      <AppRoute path="/botWeekly" exact={true} component={BotWeekly} />

      <AppRoute path="/licenseManage" exact={true} component={LicenseManage} />
      <AppRoute
        path="/licenseSysManage"
        exact={true}
        component={LicenseSysManage}
      />
      <AppRoute path="/licenseReqMng" exact={true} component={LicenseReqMng} />
      <AppRoute path="/licenseBuyMng" exact={true} component={LicenseBuyMng} />
      <AppRoute
        path="/licenseSysBuyMng"
        exact={true}
        component={LicenseSysBuyMng}
      />

      <Redirect from="*" to="/" />
    </Switch>
  );
}
